import { useEffect } from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';

export const usePeopleDirectoryPageView = (key?: string): void => {
  const { track } = useTracking();
  useEffect(() => {
    track({
      type: 'pageview',
      channel: 'wbm/People_Directory',
      page: `wbm/People_Directory/${key}`,
    });
  }, [key, track]);
};
